import classNames from 'classnames';
import Button from 'components/button';
import { reverse } from 'core/urls';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from './styles.css';

export default class ClRefundOrderSuccess extends Component {
    static propTypes = {
        border: PropTypes.bool,
        title: PropTypes.string,
        orderId: PropTypes.number,
    };

    render() {
        const className = classNames(styles.root, this.props.className, {
            [styles.border]: this.props.border,
        });

        return (
            <div className={className}>
                <div className={styles.title}>
                    {this.props.title}
                </div>
                <div className={styles.subtitle}>
                    El número de pedido es #{this.props.orderId}
                </div>
                <div className={styles.mainActions}>
                    <Button link={reverse('clDealerKitsCreate', { id: this.props.orderId })} theme='yellow'>
                        Si ya sabes la fecha de tu Campo líder, pedí tu invitación acá
                    </Button>
                </div>
                <div className={styles.actions}>
                    <Button link={reverse('orderDetail', { id: this.props.orderId })} theme='yellow'>
                        Ver detalle del pedido
                    </Button>
                    <Button link={reverse('home')} theme='yellow'>
                        Volver al inicio
                    </Button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/cl-refund-order-success/index.js